var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg004Stop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#334347"
    },
    d: "M150.563,45.847H91.27c-23.208,0-42.091,18.881-42.091,42.09c0,3.764,2.808,6.949,6.54,7.443 c0.182,0.024,18.453,2.565,38.251,15.52c26.292,17.206,42.848,43.843,49.207,79.173c0.648,3.602,3.785,6.176,7.38,6.176 c0.223,0,0.448-0.01,0.674-0.03c3.871-0.345,6.838-3.59,6.838-7.475V53.353C158.068,49.207,154.708,45.847,150.563,45.847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#334347"
    },
    d: "M150.563,192.247H91.27c-23.208,0-42.091,18.882-42.091,42.09c0,3.779,2.81,6.969,6.559,7.445 c0.177,0.023,17.913,2.397,37.676,15.156c26.615,17.184,43.356,43.944,49.763,79.534c0.648,3.602,3.785,6.176,7.38,6.176 c0.223,0,0.448-0.01,0.674-0.03c3.871-0.345,6.838-3.589,6.838-7.475V199.752C158.068,195.607,154.708,192.247,150.563,192.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#334347"
    },
    d: "M150.563,338.645H91.27c-23.208,0-42.091,18.882-42.091,42.09c0,3.779,2.81,6.969,6.559,7.445 c0.177,0.022,17.913,2.397,37.676,15.156c26.615,17.184,43.356,43.944,49.763,79.534c0.648,3.602,3.785,6.176,7.38,6.176 c0.223,0,0.448-0.01,0.674-0.03c3.871-0.345,6.838-3.589,6.838-7.475V346.151C158.068,342.006,154.708,338.645,150.563,338.645z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B373A"
    },
    d: "M150.563,338.645h-26.194v95.221c9.121,13.785,15.415,30.155,18.807,49.004 c0.648,3.602,3.785,6.176,7.38,6.176c0.223,0,0.448-0.01,0.674-0.03c3.871-0.345,6.838-3.589,6.838-7.475V346.151 C158.068,342.006,154.708,338.645,150.563,338.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B373A"
    },
    d: "M150.563,192.247h-26.194v95.221c9.121,13.785,15.415,30.155,18.807,49.004 c0.648,3.602,3.785,6.176,7.38,6.176c0.223,0,0.448-0.01,0.674-0.03c3.871-0.345,6.838-3.589,6.838-7.475V199.752 C158.068,195.607,154.708,192.247,150.563,192.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B373A"
    },
    d: "M150.563,45.847h-26.194v95.229c9.122,13.786,15.416,30.154,18.807,48.996 c0.648,3.602,3.785,6.176,7.38,6.176c0.223,0,0.448-0.01,0.674-0.03c3.871-0.345,6.838-3.59,6.838-7.475V53.353 C158.068,49.207,154.708,45.847,150.563,45.847z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#334347"
    },
    d: "M361.436,45.847h59.293c23.208,0,42.091,18.881,42.091,42.09c0,3.764-2.808,6.949-6.54,7.443 c-0.182,0.024-18.453,2.565-38.251,15.52c-26.292,17.206-42.848,43.843-49.207,79.173c-0.648,3.602-3.785,6.176-7.38,6.176 c-0.223,0-0.448-0.01-0.674-0.03c-3.871-0.345-6.838-3.59-6.838-7.475V53.353C353.931,49.207,357.291,45.847,361.436,45.847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#334347"
    },
    d: "M361.436,192.247h59.293c23.208,0,42.091,18.882,42.091,42.09c0,3.779-2.81,6.969-6.559,7.445 c-0.177,0.023-17.913,2.397-37.676,15.156c-26.615,17.184-43.356,43.944-49.763,79.534c-0.648,3.602-3.785,6.176-7.38,6.176 c-0.223,0-0.448-0.01-0.674-0.03c-3.871-0.345-6.838-3.589-6.838-7.475V199.752C353.931,195.607,357.291,192.247,361.436,192.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#334347"
    },
    d: "M361.436,338.645h59.293c23.208,0,42.091,18.882,42.091,42.09c0,3.779-2.81,6.969-6.559,7.445 c-0.177,0.022-17.913,2.397-37.676,15.156c-26.615,17.184-43.356,43.944-49.763,79.534c-0.648,3.602-3.785,6.176-7.38,6.176 c-0.223,0-0.448-0.01-0.674-0.03c-3.871-0.345-6.838-3.589-6.838-7.475V346.151C353.931,342.006,357.291,338.645,361.436,338.645z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B373A"
    },
    d: "M361.436,338.645h26.194v95.221c-9.121,13.785-15.415,30.155-18.807,49.004 c-0.648,3.602-3.785,6.176-7.38,6.176c-0.223,0-0.448-0.01-0.674-0.03c-3.871-0.345-6.838-3.589-6.838-7.475V346.151 C353.931,342.006,357.291,338.645,361.436,338.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B373A"
    },
    d: "M361.436,192.247h26.194v95.221c-9.121,13.785-15.415,30.155-18.807,49.004 c-0.648,3.602-3.785,6.176-7.38,6.176c-0.223,0-0.448-0.01-0.674-0.03c-3.871-0.345-6.838-3.589-6.838-7.475V199.752 C353.931,195.607,357.291,192.247,361.436,192.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B373A"
    },
    d: "M361.436,45.847h26.194v95.229c-9.122,13.786-15.416,30.154-18.807,48.996 c-0.648,3.602-3.785,6.176-7.38,6.176c-0.223,0-0.448-0.01-0.674-0.03c-3.871-0.345-6.838-3.59-6.838-7.475V53.353 C353.931,49.207,357.291,45.847,361.436,45.847z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546F7A"
    },
    d: "M342.07,0H169.929c-14.817,0-26.872,12.054-26.872,26.871v458.258 c0,14.816,12.054,26.871,26.872,26.871h172.141c14.817,0,26.872-12.054,26.872-26.871V26.871C368.941,12.054,356.887,0,342.07,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#475D63"
    },
    d: "M342.07,0h-34.512c14.817,0,26.872,12.054,26.872,26.871v458.258 c0,14.816-12.054,26.871-26.872,26.871h34.512c14.817,0,26.872-12.054,26.872-26.871V26.871C368.941,12.054,356.887,0,342.07,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4CE166"
    },
    d: "M255.999,338.645c-35.524,0-64.424,28.9-64.424,64.424s28.9,64.424,64.424,64.424 s64.424-28.9,64.424-64.424C320.423,367.547,291.523,338.645,255.999,338.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDB56"
    },
    d: "M255.999,192.247c-35.524,0-64.424,28.9-64.424,64.424s28.9,64.424,64.424,64.424 s64.424-28.9,64.424-64.424S291.523,192.247,255.999,192.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4A4A"
    },
    d: "M255.999,45.847c-35.524,0-64.424,28.9-64.424,64.424c0,35.523,28.9,64.424,64.424,64.424 s64.424-28.9,64.424-64.424C320.423,74.748,291.523,45.847,255.999,45.847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44C868"
    },
    d: "M255.999,442.032c-31.167,0-57.229-22.247-63.155-51.693c-0.829,4.117-1.269,8.373-1.269,12.731 c0,35.524,28.9,64.424,64.424,64.424s64.424-28.9,64.424-64.424c0-4.357-0.44-8.613-1.269-12.731 C313.228,419.785,287.165,442.032,255.999,442.032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBB24"
    },
    d: "M255.999,295.634c-31.167,0-57.229-22.247-63.155-51.693c-0.829,4.117-1.269,8.373-1.269,12.731 c0,35.524,28.9,64.424,64.424,64.424s64.424-28.9,64.424-64.424c0-4.357-0.44-8.613-1.269-12.731 C313.228,273.386,287.165,295.634,255.999,295.634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7343F"
    },
    d: "M255.999,149.234c-31.167,0-57.229-22.247-63.155-51.693c-0.829,4.117-1.269,8.373-1.269,12.731 c0,35.523,28.9,64.424,64.424,64.424s64.424-28.9,64.424-64.424c0-4.357-0.44-8.613-1.269-12.731 C313.228,126.987,287.165,149.234,255.999,149.234z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg004Stop);
export default __webpack_public_path__ + "static/media/004-stop.ba6817c3f6880158dddbb07ea38a1111.svg";
export { ForwardRef as ReactComponent };